// Use a free IP detection service
export const detectIP = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        window.userIP = data.ip;
        return data.ip;
    } catch (error) {
        console.error('Failed to detect IP:', error);
        window.userIP = 'unknown';
        return 'unknown';
    }
};

// Encode IP for Firebase path (replace dots with dashes)
export const encodeIP = (ip) => {
    if (!ip) return 'unknown';
    return ip.replace(/\./g, '-');
};

// Decode Firebase path back to IP
export const decodeIP = (encodedIP) => {
    if (!encodedIP || encodedIP === 'unknown') return 'unknown';
    return encodedIP.replace(/-/g, '.');
}; 